import { useEffect } from 'react';

import { useGlobalEvent } from '@luna/events';

export const useHideNavigation = (recheckId: string, condition: () => boolean) => {
    const toggleShowNavigation = useGlobalEvent('ui:navigation');

    useEffect(() => {
        if (condition()) {
            toggleShowNavigation(false);
        }

        return () => {
            toggleShowNavigation(true);
        };
    }, [recheckId]);
};
